import "./css/index.css";
import React from "react";
import { ODSAccordionSummaryProps } from "./ODSAccordion.types";
import ODSText from "../ODSText/ODSText";

const ODSAccordionSummary: React.FC<ODSAccordionSummaryProps> = ({
  children,
}) => {
  return (
    <ODSText as={"span"} className={`ODSAccordion-Header`}>
      {children}
    </ODSText>
  );
};

export default ODSAccordionSummary;
